import { getCreatorDefsites } from './divideDefsitesByOrigin.js';

export function getBodyListNames() {
    return getCreatorDefsites().map(k => k.listName);
}

export function getListNames() {
    return getBodyListNames().concat(require('../assets/elements.json').globalTypes);
}

export function getEmptyCreatorLists() {
    const listNames = getListNames();
    const retval = {};
    listNames.forEach(name => retval[name] = []);
    return retval;
}

export const getPathToTypeList = () => getCreatorDefsites().map((site, index, arr) => {
    const prevPagePath = index > 0 && arr[index - 1].creatorPath || null;
    const nextPagePath = index < (arr.length - 1) && arr[index + 1].creatorPath || null;
    
    return {
        path: site.creatorPath,
        type: site.listName.slice(0, -4),
        pageTranslationKey: site.pageTranslationKey,
        index: index,
        listName: site.listName,
        prevPagePath: prevPagePath,
        nextPagePath: nextPagePath
    };
})

